import { render, staticRenderFns } from "./purchaseInquiry.vue?vue&type=template&id=426ce0da&scoped=true"
import script from "./purchaseInquiry.vue?vue&type=script&lang=js"
export * from "./purchaseInquiry.vue?vue&type=script&lang=js"
import style0 from "./purchaseInquiry.vue?vue&type=style&index=0&id=426ce0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ce0da",
  null
  
)

export default component.exports